// apiConfig.js
//const API_BASE_URL = "http://localhost/adminreact/backend/api/";
//const API_BASE_URL = "https://squeff.com.ar/pruebas/api/api/";
const API_BASE_URL = "https://api.web.sushimania.com.ar/";

const BASE_URL_QR = "http://www.squeff.com.ar/productos.php?pid";
//const BASE_URL_QR = "http://localhost/adminproducto/index.php?pid";

const RUTAPRODUCTOSIMAGENES =  API_BASE_URL + "uploads/imagenesproductos/";
const NOMBRECARTA = "carta.pdf";

const RUTACARTAPDF =  API_BASE_URL + "uploads/pdfs/"+NOMBRECARTA;

const TIEMPOEXPIRACIONCOOKIEENMINUTOS = 5; //minutos

const LOGIN = "login.php";
const LOGOUT = "logout.php";
const USERACTUALIZAR = "userActualizar.php";
const SIGIN = "register.php";
const USERLIST = "userlist.php";

const PRODUCTOALTA = "productoalta.php";
const PRODUCTOELIMINAR = "productoeliminar.php";
const PRODUCTOEDITAR = "productoeditar.php";
const PRODUCTOSLISTS = "productoslistar.php";
const PRODUCTOFOTOS = "productogetfotos.php";
const ELIMINARFOTO = "productoeliminarfoto.php";

const PEDIDOSLISTS = "pedidoslistar.php";
const PEDIDOSDETALLESVER = "pedidosdetallever.php";

const RUBROSLISTAR = "rubroslistar.php";
const ALTACARTAPDF = "carta.php"

const PRECIOENVIO = "envioget.php";
const PRECIOENVIOALTA = "envioalta.php";

const SUCURSALESLISTAR = "sucursaleslistar.php";
const SUCURSALACTUALIZAR = "sucursalactualizar.php";
const SUCURSALACTUALIZARFECHACIERRE = "sucursalactualizarfechacierre.php";

const USUARIOACCION = "usuarioaccion.php";
const USUARIOACCIONLISTAR = "usuarioaccioneslistar.php";

const CUPONESLISTAR = "cuponeslistar.php";
const CUPONESACTUALIZAR = "cuponesactualizar.php";
const CUPONESAGREGAR = "cuponesagregar.php";

const FECHAHORA = "getfechahora.php";

const LOGERRORINSERT = "logerror.php";
const ERRORESLIST = "erroreslistar.php";


const AUDITORIA = "auditoria.php";
const AUDITORIALISTAR = "auditorialistar.php";

export { API_BASE_URL, LOGIN, LOGOUT, SIGIN, USERACTUALIZAR, USERLIST, PRODUCTOALTA, PRODUCTOSLISTS, 
    RUTAPRODUCTOSIMAGENES, PRODUCTOEDITAR, PRODUCTOFOTOS, ELIMINARFOTO, RUBROSLISTAR, PEDIDOSLISTS,
    PEDIDOSDETALLESVER, PRODUCTOELIMINAR, RUTACARTAPDF, ALTACARTAPDF,
    PRECIOENVIO, PRECIOENVIOALTA, SUCURSALESLISTAR, SUCURSALACTUALIZAR, SUCURSALACTUALIZARFECHACIERRE, 
    USUARIOACCION,USUARIOACCIONLISTAR,ERRORESLIST,
    CUPONESLISTAR,CUPONESACTUALIZAR, CUPONESAGREGAR,
    FECHAHORA, LOGERRORINSERT, AUDITORIA, AUDITORIALISTAR, BASE_URL_QR, TIEMPOEXPIRACIONCOOKIEENMINUTOS };